import { shiftBriefingQueryKeys as e } from "./useShiftBriefingQueryKeys.mjs";
import { aiApi as t } from "@maat/api-ai";
import { useQuery as n } from "@maat/store-hooks";
//#region src/shiftBriefing/useShiftBriefingQuery.ts
var r = ({ propertyId: r, date: i }, a) => n({
	queryKey: e.briefing(r, i),
	queryFn: () => t.getShiftBriefing({
		property_id: r,
		...i ? { date: i } : {}
	}),
	enabled: !!r && (a?.enabled ?? !0),
	staleTime: 5 * 6e4,
	retry: !1
});
//#endregion
export { r as useShiftBriefingQuery };
